import useFetch from "../hooks/useFetch";
import { useStoreState } from "../store/useStore";

export type AccountMode =
  | "ACCOUNT_LEVEL_NORMAL"
  | "ACCOUNT_LEVEL_SPOT"
  | "ACCOUNT_LEVEL_SPOT_FUTURES"
  | "ACCOUNT_LEVEL_MULTI_CURRENCY";

export type UpgradeState = "INIT" | "PROCESSING" | "FINISH";

export type getAccountUpgradeStateResponse = {
  upgrade_state: UpgradeState;
};

export type SetAccountModeParams = {
  type: "UPGRADE" | "SWITCH";
  new_account_level?: AccountMode;
};

export type GetAccountModeResponse = {
  account_level: AccountMode;
};

const useAction = () => {
  const { baseUrl } = useStoreState();

  const { post, get } = useFetch(baseUrl);

  const getAccountMode = async <T>() => {
    return post<T>(`uapi/v1/uc/account_level/query`);
  };

  const getUserAsset = async <T>() => {
    return get<T>("uapi/v1/account/overview?quote_currency=USDT");
  };

  const getExchangeRate = async <T>() => {
    return post<T>("sapi/v1/exchange_rate/rates");
  };

  return {
    getAccountMode,
    getUserAsset,
    getExchangeRate
  };
};

export default useAction;
